<div class="fundo" role="dialog" aria-modal="true" aria-label="Trocar paciente">
  <div class="modal estreito">
    <div class="modal-cab">
      <div class="cab-ico" aria-hidden="true"><svg class="i" viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20c.8-3.5 3.4-5.5 6.5-5.5 1.6 0 3 .5 4.1 1.4M16 13l3 3-3 3M22 16h-6" /></svg></div>
      <div class="cab-txt">
        <b>Trocar paciente</b>
        <span>{{ linha.hrInicio }} · {{ dataBr }}{{ linha.dsAgenda ? ' · ' + linha.dsAgenda : '' }}</span>
      </div>
      <button type="button" class="btn-ico fechar-modal" title="Fechar" (click)="cancelar()" [disabled]="salvando">
        <svg class="i" viewBox="0 0 24 24"><path d="M6 6l12 12M18 6 6 18" /></svg>
      </button>
    </div>

    <div class="modal-corpo">
      <div class="origem">
        <div>
          <span class="sub2">Paciente atual</span>
          <b>{{ linha.paciente.nmPaciente }}</b>
          <span class="sub2">{{ formatarCpf(linha.paciente.nrCpf) || 'Sem CPF' }}</span>
        </div>
        <span class="seta"><svg class="i" viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6" /></svg></span>
        <div>
          <ng-container *ngIf="novo; else buscar">
            <span class="sub2">Novo paciente</span>
            <b>{{ novo.nome }}</b>
            <span class="sub2">{{ formatarCpf(novo.cpf) || 'Sem CPF' }}</span>
          </ng-container>
          <ng-template #buscar><span class="sub2">Busque o novo paciente</span></ng-template>
        </div>
      </div>

      <app-agenda-paciente
        [detalhes]="false"
        [bloqueado]="salvando"
        (pacienteMudou)="aoMudarPaciente($event)"
        (planoCarregado)="aoCarregarPlano($event)"
      ></app-agenda-paciente>

      <div class="alerta warn" *ngIf="novo && !mesmo">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
        <div><b>Atenção:</b> você selecionou um paciente diferente. Ao salvar, o paciente do agendamento será trocado.</div>
      </div>
      <div class="alerta warn" *ngIf="aviso224 as a">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
        <div>{{ a }}</div>
      </div>
      <div class="alerta bad" *ngIf="mesmo">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
        <div>É o mesmo paciente do agendamento. Escolha outro para trocar.</div>
      </div>
      <div class="alerta info">
        <svg class="i sm" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></svg>
        <div>Horário, classificação, convênio e canal ficam iguais; só muda o titular do horário. A troca fica no log de auditoria.</div>
      </div>
      <div class="alerta bad" *ngIf="erro" role="alert">
        <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
        <div>{{ erro }}</div>
      </div>
    </div>

    <div class="modal-rod">
      <button type="button" class="btn btn-contorno" (click)="cancelar()" [disabled]="salvando">Voltar</button>
      <button type="button" class="btn btn-primario" (click)="confirmar()" [disabled]="!novo || mesmo || salvando">
        <svg class="i sm" viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.5a3.5 3.5 0 0 1 0 7M18 14a6 6 0 0 1 3.5 6" /></svg>
        {{ salvando ? 'Gravando...' : 'Trocar paciente' }}
      </button>
    </div>
  </div>
</div>
